module.exports = __webpack_public_path__ + "static/media/eva_logo.97584be0.jpg";